import {
	hero1Image,
	hero2Image,
	hero3Image,
	hero1MobileImage,
	hero2MobileImage,
	hero3MobileImage,
	educationImage,
	volunteerImage,
	giveImage,
	headphoneImage,
	ladyImage,
	ballonsImage,
} from "../images";

export const heroData = [
	{
		imageSource: [hero1Image, hero1MobileImage],
		heading: "Holistic Education",
		descriptions: [
			`“Education is the most powerful weapon which you can use to change the world.”`,
			`(Nelson Mandela)`,
		],
	},
	{
		imageSource: [hero2Image, hero2MobileImage],
		heading: "Goal-driven Communities",
		descriptions: [
			"“Alone, we can do so little; together we can do so much” ",
			"Helen Keller",
		],
	},
	{
		imageSource: [hero3Image, hero3MobileImage],
		heading: "Relief Poverty",
		descriptions: [
			"“Anyone who has struggled with poverty knows how extremely expensive it is to be poor” ",
			"James Baldwin (1924 - 1987)",
		],
	},
];

export const exploreSectionData = [
	{
		imageSource: educationImage,
		heading: "Holistic Education",
		description: [
			"Integrated learning approach to develop the intellectual,	emotional, moral, social and physical well-being of community members.",
			"“By education, I mean an all-round drawing of the best in child and man in body, mind and spirit” Mahatma Gandhi",
		],
		link: "/about-us/our-story",
		imageClass: "educate",
	},
	{
		imageSource: volunteerImage,
		heading: "Volunteer",
		description: [
			"Looking to volunteer? We’d love to hear from you.",
			"“Volunteers do not necessary have the time, they have the HEART” Elizabeth Andrew",
		],
		link: "/get-involved/#volunteer",
		imageClass: "volunteer",
	},
	{
		imageSource: giveImage,
		heading: "Ways to give",
		description: [
			"HeadHeartHand Foundation is a non-profit registered charity, community-owned and community-supported, all of our donations come directly from generous community members like YOU! In such uncertain times it can help to reach out to our neighbours and support those in need. Charity Registration Number: 794511469 RR0001",
		],
		link: "/donate",
		imageClass: "donate",
	},
];

export const newsSectionData = [
	{
		imageSource: headphoneImage,
		heading: "Sign up for our mentorship program.",
		description:
			"Our unique mentorship program is tailored to provide Holistic Education to both mentors and mentees and open to all members of the public from age 19 (nineteen).",
		linkTo: "http://bit.ly/3hmentorship",
	},
	{
		imageSource: ladyImage,
		heading: "International Women’s Day 2021",
		description:
			"As part of the celebration of the IWD 2021, we interviewed some wonderful women to share their life experiences with us.",
		linkTo: "https://www.youtube.com/channel/UCl3dF7HZprXnpT65yNjRwoA",
	},
	{
		imageSource: ballonsImage,
		heading: "Support for our Community",
		description:
			"We are receiving donations to provide shelter, food, health services, and housing support to our city’s most vulnerable people. Come and partner with us.",
		linkTo: "/donate",
	},
];
